function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "className", "disabled", "legend", "legendProps", "showLegend"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import { FieldsetLooks } from "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import { getFieldsetTheme } from "../../../../styles/styled-components/fieldset.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseFieldset } from "../base-fieldset/base-fieldset.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardFieldset = function BaseStandardFieldset(props) {
  var _classnames;
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    legend = props.legend,
    legendProps = props.legendProps,
    _props$showLegend = props.showLegend,
    showLegend = _props$showLegend === void 0 ? true : _props$showLegend,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseFieldset, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-fieldset__standard': true
    }, _defineProperty(_classnames, "bf-fieldset__standard--".concat(disabled), disabled), _defineProperty(_classnames, "".concat(className), className), _classnames)),
    disabled: disabled
  }), /*#__PURE__*/React.createElement("legend", _extends({}, legendProps, {
    className: classnames(_defineProperty({
      'bf-fieldset__standard-legend': true,
      'bf-fieldset__standard-legend--hidden': !showLegend
    }, "".concat(legendProps === null || legendProps === void 0 ? void 0 : legendProps.className), !!(legendProps !== null && legendProps !== void 0 && legendProps.className)))
  }), legend), children);
};
var Fieldset = styled(BaseStandardFieldset)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-style: solid;\n  border-width: 1px;\n  display: block;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  padding: 30px;\n  ", "\n\n  .bf-fieldset__standard-legend {\n    display: block;\n    font-family: ", ";\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px;\n    margin-bottom: 20px;\n    padding: 0;\n    position: relative;\n    top: 35px;\n    ", "\n  }\n"])), fontFamilyBook, function (_ref) {
  var look = _ref.look;
  return getFieldsetTheme({
    look: look
  });
}, fontFamilyBook, function (_ref2) {
  var showLegend = _ref2.showLegend;
  return showLegend ? '' : screenReaderOnly;
});
/**
 * A fieldset is used to group several controls and labels within a form.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/fieldset
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend
 *
 * @param props StandardFieldsetProps
 * @returns FunctionComponent<StandardFieldsetProps>
 */
var StandardFieldset = function StandardFieldset(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? FieldsetLooks.Default : _props$look;
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Fieldset, _extends({}, props, {
    look: look
  })));
};
export { BaseStandardFieldset, StandardFieldset };